// Cross-app user preferences. Persisted in a parent-domain cookie so
// canvas (canvas.localhost / edit.symbols.app) and the workspace app
// (workspace.localhost / us-at.symbols.app) read the same value.

import { readCookie, writeCookie } from '@symbo.ls/sdk-bridge'

const COOKIE_PREFIX = 'smbls_pref_'
const ONE_YEAR = 60 * 60 * 24 * 365

export function getPref (key) {
  return readCookie(COOKIE_PREFIX + key)
}

export function setPref (key, value) {
  writeCookie(COOKIE_PREFIX + key, value, ONE_YEAR)
}

export function clearPref (key) {
  writeCookie(COOKIE_PREFIX + key, null, 0)
}

export const ACTIVE_ORG = 'activeOrg'
